import React from 'react';

import { ImageLightbox } from '../ImageLightbox';
import { Actions, actions, initialState, reducer } from './slice';

export const ImageLightboxContext = React.createContext<React.Dispatch<Actions> | null>(null);

export interface ImageLightboxProviderProps {
    isDisabled?: boolean;
    children: React.ReactNode;
}

/**
 * A context provider inside which you can register images.
 *
 * @family Images
 * @param ImageLightboxProviderProps
 * @returns ImageLightboxProvider
 */
export const ImageLightboxProvider: React.FC<ImageLightboxProviderProps> = ({ children, isDisabled }) => {
    const [state, dispatchAction] = React.useReducer(reducer, initialState);

    if (isDisabled) {
        // Can't just return the children without a fragment
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{children}</>;
    }

    return (
        <ImageLightboxContext.Provider value={dispatchAction}>
            <ImageLightbox
                parentElement={state.parentElement}
                isOpen={state.isOpen}
                slideshowActiveIndex={state.slideshowActiveIndex}
                onClose={() => dispatchAction(actions.close())}
                thumbnails={state.images}
            />
            {children}
        </ImageLightboxContext.Provider>
    );
};
ImageLightboxProvider.displayName = 'ImageLightboxProvider';
